import { RootState } from '../../../../utils/type';

export const selectVendorPayments = (state: RootState) => state.vendorPayments.data;
export const selectVendorPaymentsLoading = (state: RootState) => state.vendorPayments.loading;
export const selectVendorPaymentsError = (state: RootState) => state.vendorPayments.error;
export const selectVendorPaymentsDownloadError = (state: RootState) => state.vendorPayments.downloadError;
